import { categories } from "@/mocks/categories";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-16">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Warm%20minimalist%20flat%20lay%20with%20curated%20fashion%20items%20including%20camel%20coat%20leather%20loafers%20silk%20scarf%20and%20gold%20jewelry%20on%20soft%20cream%20linen%20surface%2C%20soft%20natural%20daylight%20from%20left%2C%20editorial%20catalog%20style%2C%20elegant%20harmonious%20composition%2C%20subtle%20warm%20shadows&width=1800&height=1200&seq=hero-bg-v2-01&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50/70"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <p className="text-xs md:text-sm font-medium text-primary-600 uppercase tracking-widest mb-4">
              Product Discovery Database
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground-950 leading-[1.08] mb-6">
              Hipobuy{" "}
              <span className="italic font-serif">Spreadsheet</span>
              <br />
              Shopping Guide
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              Find verified product links, trending fashion items, sneakers,
              accessories and shopping recommendations through our continuously
              updated Hipobuy Spreadsheet.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-6 py-3 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Explore Hipobuy Spreadsheet
                <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-6 py-3 text-sm font-medium text-foreground-700 border border-foreground-300 hover:bg-foreground-50 rounded-full transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Visit Main Platform
                <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 justify-center lg:justify-start">
              {["Updated Product Database", "Category Based Search", "Shopping Research Guide", "International Buyer Friendly"].map(
                (point) => (
                  <span
                    key={point}
                    className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap"
                  >
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                    {point}
                  </span>
                )
              )}
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/5] rounded-[32px] overflow-hidden bg-background-100/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20curated%20minimalist%20fashion%20including%20tan%20leather%20bag%20silk%20blouse%20gold%20watch%20and%20tortoiseshell%20sunglasses%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20product%20photography%2C%20luxurious%20composition%2C%20high%20detail&width=800&height=1000&seq=hero-product-v2-02&orientation=portrait"
                  alt="Hipobuy Spreadsheet product collection"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                {categories.slice(0, 4).map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex-1 px-3 py-2 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 hover:bg-primary-500 hover:text-background-50 transition-all text-center whitespace-nowrap cursor-pointer"
                  >
                    {cat.name.split(" / ")[0]}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}